import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { ContractParameters } from '../entities/contract-parameters';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';

@Injectable()
export class ContractParametersService extends BaseCrudService<ContractParameters> {

    public uri = '/api/contractParameters/';

    constructor(injector: Injector) {
        super(injector);
        //console.log('Instance ContractParametersService');
    }

    buildSentence(entity?: ContractParameters, event?: LazyLoadEvent): HttpParams {
        if (entity) {
            let query = '';
            query = query.concat(
                entity.code ?
                    `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
                    : QueryOperator.Empty
            );
            query = query.concat(
                entity.status ?
                    `status${QueryOperator.Equal}${entity.status}${QueryOperator.Split}`
                    : QueryOperator.Empty
            );
            query = query.concat(
                entity.startDate ?
                    `startDate${QueryOperator.Equal}${entity.startDate}${QueryOperator.Split}`
                    : QueryOperator.Empty
            );
            query = query.concat(
                entity.endDate ?
                    `endDate${QueryOperator.Equal}${entity.endDate}${QueryOperator.Split}`
                    : QueryOperator.Empty
            );
            if (entity.fiscalYear && entity.fiscalYear.id) {
                query = query.concat(
                    `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
                );
            }
            if (entity.executingUnit && entity.executingUnit.id) {
                query = query.concat(
                    `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
                );
            }
            if (entity.employeeType && entity.employeeType.id) {
                query = query.concat(
                    `employeeType.id${QueryOperator.Equal}${entity.employeeType.id}${QueryOperator.Split}`
                );
            }
            if (entity.formatType && entity.formatType.id) {
                query = query.concat(
                    `formatType.id${QueryOperator.Equal}${entity.formatType.id}${QueryOperator.Split}`
                );
            }

            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }

    createWithAttachment(contractParameters: ContractParameters, files: File[]): Observable<any> {

        //console.log('createWithAttachment::::::::', files);

        const url = `${this.rutaServidor}${this.uri}attachment`;
        const uploadData = new FormData();
        //console.log(absenceLeave); 
        //console.log(files);
        uploadData.append('contractParameters', JSON.stringify(contractParameters))
        //console.log(uploadData);
        if (files) {
            files.forEach((file) => {
                uploadData.append('files', file, file.name);
            })
        }
        //console.log(uploadData);
        this.spinnerService.showAll();
        return this.httpClient.post<any>(url, uploadData)
            .pipe(
                tap(response => {
                    if (response.numberOfElements > 0) {
                        //console.log(response);
                        response.content.forEach((value) => {
                            // this.convertToDate(value);
                        })
                    }
                    this.spinnerService.hideAll();
                    return response;
                })
            );
    }

    downloadAttachment(entity?: ContractParameters): Observable<Blob> {
        const url = `${this.rutaServidor}${this.uri}${entity.id}/download-attachment`;
        this.spinnerService.showAll();
        return this.httpClient.get(url, { responseType: 'blob' })
            .pipe(
                tap(response => {
                    //console.log('dowloadAttachment');
                    //console.log(response);
                    this.spinnerService.hideAll();
                })
            );
    }

    updateContractParameters(contractParameters: ContractParameters, id: number, files: File[]): Observable<any> {
        
        //console.log('updateContractParameters::::::::', files);
        
        const url = `${this.rutaServidor}${this.uri}updateContractParameters`;
        const uploadData = new FormData();
        contractParameters.id = id
        uploadData.append('contractParameters', JSON.stringify(contractParameters));
        if (files) {
            files.forEach((file) => {
                uploadData.append('files', file, file.name);
            })
        }
        this.spinnerService.showAll();
        return this.httpClient.post<any>(url, uploadData)
            .pipe(
                tap(response => {
                    if (response.numberOfElements > 0) {
                        response.content.forEach((value) => {
                        })
                    }
                    this.spinnerService.hideAll();
                    return response;
                })
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/contract-parameters.service.ts